import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import React, { useCallback } from 'react'
import { useGa4Context } from '../context/Ga4Context'
import useGa4 from '../hooks/useGa4'

//export const matchNothingRegex = /(?!)/

type TextFieldRegexProps = TextFieldProps & {
  regex?: RegExp
  // onChange: (e: any) => void;
  // onFocus: (e: any) => void;
}

const TextFieldRegex = (props: TextFieldRegexProps) => {
  const { regex, onChange, onFocus, variant, ...rest } = props

  const ga4Data = useGa4Context().ga4Data
  const {ga4_formFieldClick} = useGa4()

  const handleChange = useCallback(
    (e: any) => {
      e.currentTarget.value = e.currentTarget.value.replace(regex, '')
      if (onChange !== undefined) {
        onChange(e)
      }
    },
    [onChange, regex]
  )

  const handleFocus = useCallback(
    (e: any) => {
      ga4_formFieldClick({ case_type: ga4Data?.case_type, step: ga4Data?.step, form_name: ga4Data?.form_name, field_name: props.name })
      if (onFocus !== undefined) {
        onFocus(e)
      }
    }, [ga4_formFieldClick, ga4Data, props.name, onFocus]
  )

  return <TextField onChange={handleChange} onFocus={handleFocus} {...rest} />
}

export default React.memo(TextFieldRegex)
